import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AcademicYearResponse,
  FacultyResponse,
  SpecialityResponse,
  TeacherResponse,
  DegreeResponse,
  SpecialityModeResponse,
  ExamTypeResponse,
} from "../../models/dtos";
import { RootState } from "../../store";

const initialState = {
  filters: {
    faculties: [] as FacultyResponse[],
    specialities: [] as SpecialityResponse[],
    teachers: [] as TeacherResponse[],
    examTypes: [] as ExamTypeResponse[],
    academicYears: [] as AcademicYearResponse[],
    degrees: [] as DegreeResponse[],
    eduForms: [] as SpecialityModeResponse[],
  },
};

const protocolsSlice = createSlice({
  name: "protocols",
  initialState,
  reducers: {
    setSelectedFaculties: (state, action: PayloadAction<FacultyResponse[]>) => {
      state.filters.faculties = action.payload;
    },
    setSelectedTeachers: (state, action: PayloadAction<TeacherResponse[]>) => {
      state.filters.teachers = action.payload;
    },
    setSelectedSpecialities: (state, action: PayloadAction<SpecialityResponse[]>) => {
      state.filters.specialities = action.payload;
    },
    setSelectedAcademicYears: (state, action: PayloadAction<AcademicYearResponse[]>) => {
      state.filters.academicYears = action.payload;
    },
    setSelectedDegrees: (state, action: PayloadAction<DegreeResponse[]>) => {
      state.filters.degrees = action.payload;
    },
    setSelectedEduForms: (state, action: PayloadAction<SpecialityModeResponse[]>) => {
      state.filters.eduForms = action.payload;
    },
      setSelectedExamTypes: (state, action: PayloadAction<ExamTypeResponse[]>) => {
      state.filters.examTypes = action.payload;
    },
    clearProtocolFilters: (state) => {
      state.filters = {
        ...initialState.filters,
        academicYears: [],
      };
    },
  },
});

export const {
  setSelectedFaculties,
  setSelectedSpecialities,
  setSelectedTeachers,
  setSelectedAcademicYears,
  setSelectedDegrees,
  setSelectedEduForms,
  setSelectedExamTypes,
  clearProtocolFilters,
} = protocolsSlice.actions;

export const getSelectedFaculties = (state: RootState) => state.protocols.filters.faculties;
export const getSelectedSpecialities = (state: RootState) => state.protocols.filters.specialities;
export const getSelectedTeachers = (state: RootState) => state.protocols.filters.teachers;
export const getSelectedAcademicYears = (state: RootState) => state.protocols.filters.academicYears;
export const getSelectedDegrees = (state: RootState) => state.protocols.filters.degrees;
export const getSelectedEduForms = (state: RootState) => state.protocols.filters.eduForms;
export const getSelectedExamTypes = (state: RootState) => state.protocols.filters.examTypes;

export const getProtocolsFilters = (state: RootState) => state.protocols.filters;
export const getProtocolsFiltersCount = (state: RootState) => {
  const filters = state.protocols.filters;
  let count = 0;

  if (filters?.faculties?.length > 0) count += filters.faculties.length;
  if (filters?.specialities?.length > 0) count += filters.specialities.length;
  if (filters?.teachers?.length > 0) count += filters.teachers.length;
  if (filters?.academicYears?.length > 0) count += filters.academicYears.length;
  if (filters?.degrees?.length > 0) count += filters.degrees.length;
  if (filters?.eduForms?.length > 0) count += filters.eduForms.length;
  if (filters?.examTypes?.length > 0) count += filters.examTypes.length;

  return count;
};

export default protocolsSlice.reducer;
